import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import './map.css'
import L from "leaflet";
import icon from '../../assets/favv-icon.png'
import { useEffect } from 'react';
import { useState } from 'react';
import Feedback from './feedback';


const Mapcomponent = ({ lat, lng }) => {


 const [showFeedback, setShowFeedback] = useState(false);


  useEffect(() => {
    setShowFeedback(true);
  }, []);



        if (!lat || !lng) return <p>No location</p>;



     const customIcon = new L.Icon({
  iconUrl: icon,
  iconSize: [37, 38],
});   


    return (  

<>
          <MapContainer
            center={[lat, lng]}
            zoom={13}
            className='main-map-view'
          >
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            
      <Marker position={[lat, lng]} icon={customIcon}>
        <Popup>Exhibition Location</Popup>
      </Marker>
          </MapContainer>

{showFeedback && (
  <Feedback onClose={() => setShowFeedback(false)} />
)}
</>

    );
}
 
export default Mapcomponent;